import { render, staticRenderFns } from "./MedicalGuidancePage.vue?vue&type=template&id=7962f04a&scoped=true"
import script from "./MedicalGuidancePage.vue?vue&type=script&lang=js"
export * from "./MedicalGuidancePage.vue?vue&type=script&lang=js"
import style0 from "./MedicalGuidancePage.vue?vue&type=style&index=0&id=7962f04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7962f04a",
  null
  
)

export default component.exports